import { createSelector } from 'reselect';
import { filter, get, has } from 'lodash';
import { buildRequestQuotesByRequestIdSelector } from 'store/selectors/requestQuotes.selector';
import { buildReservationSelector } from './reservations.selector';

/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => state.app.database.requests;
const getMetaEntities = (state) => state.app.metaDatabase.requests;
const getExternalIdentifiers = (state) => state.app.database.externalIdentifiers;
const getMembers = (state) => state.app.database.members;
const getMemberEmails = (state) => state.app.database.memberEmails;
const getDocuments = (state) => state.app.database.requestDocuments;
const getUsers = (state) => state.app.database.users;
const getTravelAgencies = (state) => get(state, 'app.database.travelAgencies', {});
/**
 * Selector Builders
 */
export const buildMetaRequestSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, metaEntities) =>
{
    if (has(metaEntities, entityId))
    {
        return metaEntities[entityId];
    }

    return {};
});

export const buildRequestSelector = () => createSelector([
    getEntityId,
    getEntities,
    getMembers,
    getMemberEmails,
    getExternalIdentifiers,
    getUsers,
    getTravelAgencies,
    getDocuments,
    buildRequestQuotesByRequestIdSelector(),
], (entityId, entities, members, membersEmails, externalIdentifiers, users, travelAgencies, documents, requestsQuotes) =>
{
    if (has(entities, entityId))
    {
        const request = entities[entityId];
        const member = get(members, get(request, 'member_id'));
        const memberEmails = filter(membersEmails, { member_id: get(request, 'member_id') });
        const travelAgency = get(travelAgencies, { travel_agency: get(member, 'travel_agency_id') });
        const requestDocuments = filter(documents, { request_id: entityId });
        const user = get(users, get(request, 'user_id'));
        const requestExternalIdentifiers = filter(externalIdentifiers, { local_type: 'Request', local_id: request.id });
        const requestQuotes = filter(requestsQuotes, { request_id: entityId });

        return {
            ...request,
            externalIdentifiers: requestExternalIdentifiers,
            member: { ...member, memberEmails, travelAgency },
            user,
            requestDocuments,
            requestQuotes,
        };
    }

    return {};
});

export const buildRequestByReservationIdSelector = () =>
{
    const getReservation = buildReservationSelector();

    return createSelector([getReservation, getEntities], (reservation, requests) =>
    {
        if (has(reservation, 'request_id') && has(requests, reservation.request_id))
        {
            return requests[reservation.request_id];
        }

        return {};
    });
};
